import React from 'react';
import DC from '../../../common/DataConnector';
import { i18n } from '../../../lang/i18n';
import { credentialSave } from '../../../store/UserData/UserData';
import { useParams } from 'react-router-dom';
import { actAlertShow } from '../../../store/Actions';
import { useAppDispatch } from '../../../store/hooks';


export default function UserLoginEmulate()
{
    const dispatch = useAppDispatch()
	const { customerId } = useParams()

	React.useEffect(() =>
	{
		(async function ()
		{
			await check_login()
		})();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	async function check_login()
	{
		const result = await DC.Post('/customer/login-emulate/' + customerId, {});
		if (result.wasOk) {
			if (result.data && result.data.length > 11)
				credentialSave(result.data, dispatch)
			else if (result.data === 'error_date') {
				actAlertShow(dispatch, 'danger', i18n.CustomerLogin.LoginErrorDate, 3);
			} else {
				actAlertShow(dispatch, "danger", i18n.CustomerLogin.LoginErrorInfo, 3);
			}
		} else {
			actAlertShow(dispatch, "danger", i18n.CustomerLogin.LoginErrorInfo, 3);
		}
	}

	return (<div className='login'>
		<div style={{ paddingTop: 30 }}>
			<h4 style={{ textAlign: 'center' }}>
				{i18n.CustomerLogin.Login}
			</h4>
		</div>
	</div>
	);
}